import { createContext } from 'react';
import { createStoreContext } from 'ariakit-utils/store';
var MenuBarContext = createStoreContext();
var MenuContext = createStoreContext();
var MenuItemCheckedContext = /*#__PURE__*/createContext(undefined);

function hasExpandedMenuButton(items, currentElement) {
  return !!(items != null && items.filter(function (item) {
    return item.ref.current !== currentElement;
  }).some(function (item) {
    var _item$ref$current;

    return ((_item$ref$current = item.ref.current) == null ? void 0 : _item$ref$current.getAttribute("aria-expanded")) === "true";
  }));
}

export { MenuContext as M, MenuBarContext as a, MenuItemCheckedContext as b, hasExpandedMenuButton as h };